// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ObjectWithImages_container__fMKmt {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
  border-radius: 8px;
}

.ObjectWithImages_imagesContainer__iMcgB {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.ObjectWithImages_imageWrapper__8HiaT {
  width: 20px;
  height: 20px;
  transition: width 2s ease 1s, height 2s ease 1s;
  border-radius: 4px;
  overflow: hidden;
}
.ObjectWithImages_imageWrapper__8HiaT:hover {
  width: 150px;
  height: 150px;
}

.ObjectWithImages_image__tL6eF {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ObjectWithImages_deleteButton__Ez4L5 {
  display: none;
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 5px 10px;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-family: "Arial", sans-serif;
}
.ObjectWithImages_imageWrapper__8HiaT:hover .ObjectWithImages_deleteButton__Ez4L5 {
  display: block;
}

.ObjectWithImages_uploadContainer__k5jaI {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.8rem;
}

.ObjectWithImages_uploadLabel__FtLWA {
  padding: 3px 5px;
  background-color: #2c3e50;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  font-family: "Arial", sans-serif;
}
.ObjectWithImages_uploadLabel__FtLWA:hover {
  background-color: #3e5871;
}

.ObjectWithImages_uploading__Z2mOb {
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/Components/ObjectWithImages/ObjectWithImages.module.scss"],"names":[],"mappings":"AAMA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EAEA,kBAAA;AANF;;AAWA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AARF;;AAYA;EACE,WAAA;EACA,YAAA;EAEA,+CAAA;EACA,kBAAA;EACA,gBAAA;AAVF;AAYE;EACE,YAAA;EACA,aAAA;AAVJ;;AAeA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAZF;;AAgBA;EACE,aAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,iBAAA;EACA,yBApDc;EAqDd,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAvDY;AA0Cd;AAeE;EACE,cAAA;AAbJ;;AAkBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;AAfF;;AAmBA;EACE,gBAAA;EACA,yBA1EgB;EA2EhB,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gCA7EY;AA6Dd;AAkBE;EACE,yBAAA;AAhBJ;;AAqBA;EACE,YAAA;AAlBF","sourcesContent":["// Define primary colors and fonts\n$primary-color: #3498db; // Adjust to fit your color scheme\n$secondary-color: #2c3e50; // Adjust to fit your color scheme\n$font-family: 'Arial', sans-serif;\n\n// General container styles\n.container {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 10px;\n  // background-color: #f5f5f5;\n  border-radius: 8px;\n  // box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n// Styling for the images container\n.imagesContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n}\n\n// Individual image wrapper\n.imageWrapper {\n  width: 20px; // Small initial size\n  height: 20px;\n  // background-color: grey;\n  transition: width 2s ease 1s, height 2s ease 1s; // Delayed transition for hover effect\n  border-radius: 4px;\n  overflow: hidden;\n\n  &:hover {\n    width: 150px; // Larger size on hover\n    height: 150px;\n  }\n}\n\n// Image styles\n.image {\n  display: block;\n  width: 100%; // Adjust to container's width\n  height: 100%; // Adjust to container's height\n  object-fit: cover;\n}\n\n// Delete button styling\n.deleteButton {\n  display: none; // Initially hidden\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  padding: 5px 10px;\n  background-color: $primary-color;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-family: $font-family;\n\n  .imageWrapper:hover & {\n    display: block; // Show on hover\n  }\n}\n\n// Upload section styling\n.uploadContainer {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 0.8rem; // Smaller font for a more discreet look\n}\n\n// Upload label styling\n.uploadLabel {\n  padding: 3px 5px; // Reduced padding for a more discreet button\n  background-color: $secondary-color;\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  font-family: $font-family;\n\n  &:hover {\n    background-color: lighten($secondary-color, 10%);\n  }\n}\n\n// Styles when uploading\n.uploading {\n  opacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ObjectWithImages_container__fMKmt`,
	"imagesContainer": `ObjectWithImages_imagesContainer__iMcgB`,
	"imageWrapper": `ObjectWithImages_imageWrapper__8HiaT`,
	"image": `ObjectWithImages_image__tL6eF`,
	"deleteButton": `ObjectWithImages_deleteButton__Ez4L5`,
	"uploadContainer": `ObjectWithImages_uploadContainer__k5jaI`,
	"uploadLabel": `ObjectWithImages_uploadLabel__FtLWA`,
	"uploading": `ObjectWithImages_uploading__Z2mOb`
};
export default ___CSS_LOADER_EXPORT___;
